import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    heading: translate({ id: 'gps.eventslist.view.heading' }),
  }))

  return api
}
